import type { FC } from 'react';
import { BynderFormats, getImageUrl } from '../../../../../../utils/bynder-utils';

interface Props {
    pid: string;
    name: string;
    imageUrl: string;
}

export const SuggestionsProductImage: FC<Props> = ({ pid, name, imageUrl }) => {
    const baseUrl: string = imageUrl;
    const smallUrl: string = getImageUrl(baseUrl, BynderFormats.WEBP_SMALL) || '';
    const mediumUrl: string = getImageUrl(baseUrl, BynderFormats.WEBP_MEDIUM) || '';

    // https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/img
    // Use both width and height to set the intrinsic size of the image, allowing it to take up space before it loads, to mitigate content layout shifts.
    // The combination of display: block, height: auto, and defined width/max-width ensures:
    // 1. display: block - Makes the image a block element that takes full width
    // 2. height: auto - Maintains aspect ratio as width changes
    // 3. width/max-width - Controls the image size while preventing layout shifts
    // 4. aspect-square - Forces 1:1 aspect ratio
    // Together these prevent content layout shifts (CLS) while maintaining proper image proportions
    return (
        <picture>
            <source media="(min-width: 1024px)" srcSet={mediumUrl} width="500" height="500" />
            <source media="(min-width: 1px)" srcSet={smallUrl} width="200" height="200" />
            <img
                data-testid={`header.menu.search.item.${pid}.image`}
                src={smallUrl}
                alt={name}
                width="200"
                height="200"
                className="align-self-start md:align-self-center block aspect-square h-auto max-w-[200px] xs:w-[100px] md:w-full md:max-w-[500px]"
                loading="lazy"
            />
        </picture>
    );
};
